/* eslint-disable @typescript-eslint/no-explicit-any */
export interface InputFormPayload {
  ac_system_size_estimated: number;
  ac_system_size_kw: number;
  ac_system_size_multiplier: number;
  avoided_cost_per_kwh_qt: number;
  channel_epc_cost_referral_pcnt: number;
  channel_epc_cost_referral_per_watt: number;
  channel_finl_dev_fee_referral_pcnt: number;
  channel_partner_company_name: string | number;
  custom_opp_maintain_cost_applies: 'Yes' | 'No';
  custom_opp_maintain_cost_escal: string; // Assuming escalatorOptions is a string array
  custom_opp_maintain_cost_yr1_per_kw: number;
  custom_opp_maintain_cost_yr6_per_kw: number;
  custom_useful_life_term: number;
  developer_partner_project_cod_count: number;
  disc_to_pre_system_utility_bill_pcnt_inp: number;
  epc_partner_project_cod_count: number;
  epc_total_per_watt_inp_qt: number;
  epc_total_per_watt_inp_sd: number;
  epc_total_per_watt_sd_dep: number;
  epc_total_per_watt_sd: number;
  financing_type: 'PPA' | 'Lease' | 'Feed-in-Tariff';
  itc_adder_domestic_qt: 'Yes' | 'No';
  itc_adder_domestic_pv_qt?: 'Yes' | 'No';
  itc_adder_domestic_bess_qt?: 'Yes' | 'No';
  pv_itc_safeharbored?: 'Yes' | 'No';
  itc_adder_energy_com_qt: 'Yes' | 'No';
  itc_adder_low_inc_qt: 'Yes' | 'No';
  itc_ineligible_nom_qt: number;
  kwh_per_kw_qt: number;
  kwh_per_kw_sd_dep: number;
  kwh_per_kw_sd: number;
  lease_escal_orig_term?: string; // Assuming escalatorOptions is a string array
  lease_term_yrs_num?: '15' | '20' | '25';
  offtaker_holds_rec_rights: 'Yes' | 'No';
  esa_escal_orig_term?: string;
  esa_prod_guar_included?: 'Yes' | 'No';
  esa_term_yrs_num?: '15' | '20' | '25';
  ppa_escal_orig_term?: string; // Assuming escalatorOptions is a string array
  ppa_prod_guar_included?: 'Yes' | 'No';
  ppa_term_yrs_num?: '15' | '20' | '25';
  public_entity: 'Yes' | 'No';
  public_school: 'Yes' | 'No';
  pv_size_dc_kw_sd: number;
  rec_group: 'Group A: Ameren' | 'Group B: ComEd' | 'PJM' | 'Not Applicable';
  rec_type: 'Adjustable Block Program' | 'Successor Solar Incentive (SuSI) Program' | 'VA REC' | 'Pennsylvania Tier I RECs';
  referral_partner_epc_cost_referral_pcnt: number;
  referral_partner_epc_cost_referral_per_watt: number;
  referral_partner_project_cod_count: number;
  site_lease_annual_nom: number;
  site_lease_escal: string; // Assuming escalatorOptions is a string array
  site_lease_included: 'Yes' | 'No';
  site_lease_term_inp: number;
  sr_finl_dev_fee_per_watt_inp: number;
  state_incentive_yr1_nom_qt: number;
  state_incentive_yr1_nom_sd: number;
  utility_name: string;
  referral_partner_company_name: string;
  ix_delivery_point: string; // BTM or FTM
  unilateral_auto_renewal: string;

  // battery fields
  battery_energy_rating_kwh: number;
  battery_pwr_rating_kw: number;
  ac_or_dc__c: string;
  es_system_coupling: string;
  es_oem: string;
  storage_warranty_default: string;
  storage_warranty_custom_term: number;
  storage_warranty_custom_cost: number;
  storage_additional_proj_diligence_req: string;
  storage_incentive_program: string[];

  // budget fields
  sr_trans_legal_fees_nom: number;
  referral_fees_total_nom: number;
  dev_only_expense_budget_total_nom: number;

  // site lease fields
  site_lease_solver_type: string;
  site_lease_upfront_nom: number;

  // dev_budget_exp_adjust_nom
  dev_budget_override: 'Yes' | 'No';
  dev_budget_exp_adjust_nom: number;
  dev_only_expense_budget_total_nom_inp: number;

  // sr_finl_dev_fee_bess_nom
  sr_finl_dev_fee_bess_nom: number;
  sr_finl_dev_fee_solar_nom: number;

  // decommission_bond
  decommission_bond_applies: 'Yes' | 'No';
  decommission_bond_nom: number;

  // removal_fee
  removal_fee_nom: number;

  // dev fee adjustment
  sr_finl_dev_fee_adj_appl: 'Yes' | 'No';
  sr_finl_dev_fee_inv_pv_d_1_grs_nom: number;
  sr_finl_dev_fee_inv_pv_d_2_grs_nom: number;
  sr_finl_dev_fee_inv_pv_d_3_grs_nom: number;
  sr_finl_dev_fee_inv_pv_d_1_adj_nom: number;
  sr_finl_dev_fee_inv_pv_d_2_adj_nom: number;
  sr_finl_dev_fee_inv_pv_d_3_adj_nom: number;
  sr_finl_dev_fee_inv_bess_d_1_grs_nom: number;
  sr_finl_dev_fee_inv_bess_d_2_grs_nom: number;
  sr_finl_dev_fee_inv_bess_d_3_grs_nom: number;
  sr_finl_dev_fee_inv_bess_d_1_adj_nom: number;
  sr_finl_dev_fee_inv_bess_d_2_adj_nom: number;
  sr_finl_dev_fee_inv_bess_d_3_adj_nom: number;

  // bess only system design fields
  project_type: string;
  sr_finl_dev_fee_per_kwh_inp: number;
  standalone_storage_avoided_cost: number;
  disc_to_standalone_storage_avoided_cost_inp: number;
  disc_to_standalone_storage_avoided_cost_out: number;
  capacity_payment_included: string;
  capacity_payment_rate: number;
  capacity_payment_term: number;
  capacity_payment_escalator: string;

  // minimum dev fee check fields
  sr_finl_dev_fee_nom_inp: number;
  // from /api/opportunities
  skip_minimum_dev_fee_check: boolean;
  rate_class: string;
  greenfield_subtractor: string;

  // use discount or ppa/esa/capacity payment rate as input
  discount_input_type?: 'Discount' | 'Rate';
  dollars_kwh_ppa?: number;
  dollars_kwh_esa?: number;
}

export const initializeFormPayload = (
  quoteData: any,
  systemDesignData: any,
  opportunityData: any,
  budgetData: any,
  referralData: any
): InputFormPayload => {
  const result: Partial<InputFormPayload> = {};
  // Helper function to set a value if it exists
  function setValue(key: keyof InputFormPayload, value: any) {
    if (value) {
      result[key] = value;
    }
  };

  // Populate from quoteData
  if (quoteData) {
    Object.keys(quoteData).forEach((key) => {
      const formKey = key.replace('__c', '') as keyof InputFormPayload;
      if (["storage_incentive_program"].includes(formKey)) {
        setValue(formKey, quoteData[key] ? quoteData[key].split(',') : []);
      } else {
        setValue(formKey, quoteData[key]);
      }
    });
  }

  // Populate from systemDesignData
  if (systemDesignData) {
    Object.keys(systemDesignData).forEach((key) => {
      const formKey = key.replace('__c', '') as keyof InputFormPayload;
      // if ends with _sd_dep then set the value to the value of the key without the _dep
      if (formKey.endsWith('_sd_dep')) {
        const formKeyWithoutDep = formKey.replace('_sd_dep', '_sd') as keyof InputFormPayload;
        setValue(formKeyWithoutDep, systemDesignData[key]);
      } else if (formKey.endsWith('_sd')) {
        setValue(formKey, systemDesignData[key]);
      } else if (["battery_energy_rating_kwh", "battery_pwr_rating_kw"].includes(formKey)) {
        setValue(formKey, systemDesignData[key]);
      } else if (["ac_or_dc"].includes(formKey)) {
        setValue(formKey, systemDesignData[key]);
      } else if (["es_system_coupling"].includes(formKey)) {
        setValue(formKey, systemDesignData[key]);
      }
    });
    // Ensure ix_delivery_point is set to an empty string if undefined
    // TODO: not sure why setValue only accepts non empty values
    if (systemDesignData.ix_delivery_point__c === undefined) {
      systemDesignData.ix_delivery_point__c = '';
    }
  }

  // Populate from opportunityData
  if (opportunityData) {
    Object.keys(opportunityData).forEach((key) => {
      const formKey = key.replace('__c', '') as keyof InputFormPayload;
      setValue(formKey, opportunityData[key]);
    });
  }

  if (budgetData) {
    Object.keys(budgetData).forEach((key) => {
      const formKey = key.replace('__c', '') as keyof InputFormPayload;
      setValue(formKey, budgetData[key]);
    }
    );
  }

  if (referralData) {
    Object.keys(referralData).forEach((key) => {
      const formKey = key.replace('__c', '') as keyof InputFormPayload;
      setValue(formKey, referralData[key]);
    });
  }

  // Set default values for fields that are still undefined
  setValue('ac_system_size_multiplier', result.ac_system_size_multiplier || 1.25);
  setValue('ac_system_size_estimated', result.ac_system_size_estimated || 0);
  setValue('ac_system_size_kw', systemDesignData.ac_system_size_kw__c || 0);

  // Ensure all fields have at least an empty string value
  (Object.keys(result) as Array<keyof InputFormPayload>).forEach((key) => {
    if (result[key] === undefined) {
      result[key] = undefined;
    }
  });

  return result as InputFormPayload;
}